const status = {
  WAITING_PAYMENT: 1,
  SEPARATING_ORDER: 2,
  SENT: 3,
  DELIVERED: 4,
  EXPIRED: 5,
  CANCELED: 6,
  READY_FOR_PICKUP: 7,
  IN_ANALYSIS: 8,
  REPROVED: 9,
};

export default status;

const texts = {
  [status.WAITING_PAYMENT]: 'Aguardando pagamento',
  [status.SEPARATING_ORDER]: 'Separando pedido',
  [status.SENT]: 'Em transporte',
  [status.DELIVERED]: 'Entregue',
  [status.EXPIRED]: 'Expirado',
  [status.CANCELED]: 'Cancelado',
  [status.READY_FOR_PICKUP]: 'Pronto para retirada',
  [status.IN_ANALYSIS]: 'Em análise',
  [status.REPROVED]: 'Reprovado',
};

export const getText = (status) => texts[status];